import Utilities from "./utilities";

export const MOCK_CONVERSATIONS = [
    {
        conversation_id: 661,
        conversation_sid: "CH24fd8cd662124fcea04fd3054f938623",
        conversation_name: "",
        conversation_type: "dm",
        last_message_sent_at: "2022-08-08 11:27:25",
        list_item_id: null,
        participants: [
            {
                user_id: 1,
                user_name: "kaamfuprospus",
                user_email: "kaamfuprospus@yopmail.com",
                user_profile_pic: null,
                user_identity_alias: "049fea1c9235",
                last_read_message_index: null,
            },
            {
                user_id: 652,
                user_name: "0.69250500 1658382610",
                user_email: "0.69250500 1658382610@tempkmaafu.io",
                user_profile_pic: null,
                user_identity_alias: "bfd98764f598",
                last_read_message_index: 115,
            },
        ],
    },
];
export const FILTERED_CONVERSATIONS2 = [
    {
        sid: "IM81a41e3508ac41cd9bc3fb164a5913c4",
        body: "Hi, let me know if you have any questions.",
        type: "text",
        is_media: false,
        is_text: true,
        is_state: false,
        is_payment: false,
        author: "049fea1c9235",
        is_author: false,
        author_name: "kaamfuprospus",
        sent_time: "1:50 PM",
        dateCreated:
            "[native Date Thu Jul 21 2022 00:00:00 GMT+0800 (Philippine Standard Time)]",
        key: 1660100380508,
        has_same_author_as_previous_message: false,
        is_in_same_minutue_as_previous_message: false,
        index: 0,
        last_read_by_users: [],
        data: null,
    },
    {
        sid: "IM23820acafa5c42caaa71a8357a96f6fc",
        body: "test 1",
        type: "text",
        is_media: false,
        is_text: true,
        is_state: false,
        is_payment: false,
        author: "bfd98764f598",
        is_author: true,
        author_name: "0.69250500 1658382610",
        sent_time: "7:27 PM",
        dateCreated:
            "[native Date Mon Aug 08 2022 00:00:00 GMT+0800 (Philippine Standard Time)]",
        key: 1660100380509,
        has_same_author_as_previous_message: false,
        is_in_same_minutue_as_previous_message: false,
        index: 102,
        last_read_by_users: [],
        data: null,
    },
    {
        sid: "IM902290c7c7364752a4ab0ae569e287de",
        body: "test 2",
        type: "text",
        is_media: false,
        is_text: true,
        is_state: false,
        is_payment: false,
        author: "bfd98764f598",
        is_author: true,
        author_name: "0.69250500 1658382610",
        sent_time: "7:27 PM",
        dateCreated:
            "[native Date Mon Aug 08 2022 00:00:00 GMT+0800 (Philippine Standard Time)]",
        key: 1660100380510,
        has_same_author_as_previous_message: true,
        is_in_same_minutue_as_previous_message: true,
        index: 103,
        last_read_by_users: [],
        data: null,
    },
    {
        sid: "IMfe8bbadb78974d4eb29bfb7dedf5bf88",
        body: "sample 101",
        type: "text",
        is_media: false,
        is_text: true,
        is_state: false,
        is_payment: false,
        author: "bfd98764f598",
        is_author: true,
        author_name: "0.69250500 1658382610",
        sent_time: "7:27 PM",
        dateCreated:
            "[native Date Mon Aug 08 2022 00:00:00 GMT+0800 (Philippine Standard Time)]",
        key: 1660100380511,
        has_same_author_as_previous_message: true,
        is_in_same_minutue_as_previous_message: true,
        index: 104,
        last_read_by_users: [],
        data: null,
    },
    {
        sid: "IMc19719257d9f426bb3050db157b8435a",
        body: "tefdz",
        type: "text",
        is_media: false,
        is_text: true,
        is_state: false,
        is_payment: false,
        author: "bfd98764f598",
        is_author: true,
        author_name: "0.69250500 1658382610",
        sent_time: "7:28 PM",
        dateCreated:
            "[native Date Mon Aug 08 2022 00:00:00 GMT+0800 (Philippine Standard Time)]",
        key: 1660100380511,
        has_same_author_as_previous_message: true,
        is_in_same_minutue_as_previous_message: false,
        index: 114,
        last_read_by_users: [],
        data: null,
    },
    {
        sid: "IM790bf29e795c44c9a2662202409359b8",
        body: "asd",
        type: "text",
        is_media: false,
        is_text: true,
        is_state: false,
        is_payment: false,
        author: "bfd98764f598",
        is_author: true,
        author_name: "0.69250500 1658382610",
        sent_time: "2:04 PM",
        dateCreated:
            "[native Date Tue Aug 09 2022 00:00:00 GMT+0800 (Philippine Standard Time)]",
        key: 1660100380512,
        has_same_author_as_previous_message: true,
        is_in_same_minutue_as_previous_message: false,
        index: 209,
        last_read_by_users: [],
        data: null,
    },
];

export const FILTERED_CONVERSATIONS = [
    {
        sid: "IM7536264bd255468dbf4e540058b152e3",
        body: "Okey",
        type: "text",
        is_media: false,
        is_text: true,
        is_state: false,
        is_payment: false,
        author: "b78ac7c3b348",
        is_author: false,
        author_name: "kaamfuprospus",
        sent_time: "7:07 PM",
        dateCreated: "2022-06-06T16:00:00.000Z",
        key: 1655299205490,
        has_same_author_as_previous_message: true,
        is_in_same_minutue_as_previous_message: false,
        index: 49,
        last_read_by_users: [],
        data: null,
    },
    {
        sid: "IM9ed1a4bd46f549bca0cf2bb36cb92639",
        body: "Test 23443",
        type: "text",
        is_media: false,
        is_text: true,
        is_state: false,
        is_payment: false,
        author: "b78ac7c3b348",
        is_author: false,
        author_name: "kaamfuprospus",
        sent_time: "6:39 PM",
        dateCreated: "2022-06-08T16:00:00.000Z",
        key: 1655299205490,
        has_same_author_as_previous_message: true,
        is_in_same_minutue_as_previous_message: false,
        index: 112,
        last_read_by_users: [],
        data: null,
    },
    {
        sid: "IM43d9300103464e9c878ae2bc1f31f14d",
        body: "Test 9898",
        type: "text",
        is_media: false,
        is_text: true,
        is_state: false,
        is_payment: false,
        author: "274b23b32c25",
        is_author: true,
        author_name: "caspar.maikol",
        sent_time: "7:23 PM",
        dateCreated: "2022-06-09T16:00:00.000Z",
        key: 1655299205490,
        has_same_author_as_previous_message: false,
        is_in_same_minutue_as_previous_message: false,
        index: 1589,
        last_read_by_users: [],
        data: null,
    },
    {
        sid: "IMf47cfb1e2a8b4d4c83f115a24b5b1637",
        body: "test 243",
        type: "text",
        is_media: false,
        is_text: true,
        is_state: false,
        is_payment: false,
        author: "274b23b32c25",
        is_author: true,
        author_name: "caspar.maikol",
        sent_time: "1:41 PM",
        dateCreated: "2022-06-12T16:00:00.000Z",
        key: 1655299205490,
        has_same_author_as_previous_message: true,
        is_in_same_minutue_as_previous_message: false,
        index: 1726,
        last_read_by_users: [],
        data: null,
    },
    {
        sid: "IM27c90d826d7e45b9996ed54de68d870d",
        body: "https://media.us1.twilio.com/MEd9f58b89a5474a7dd8ec07a59fa60493?Expires=1655299510&Signature=koK1xnaXH5auT2~BPNuqrdSE-nmMrrWthCNKkmJi2M50ANIJcp~pFvWCF3CbdYrNJsNv8SHkX3sGmrVPlGJ9JcE7MwYJvc4loPQ~4my-NvhAJFjro-KNr063E0dUv~HQ9Dwjo64qgXIh6Fqh0soct6Ckve4EHgMsZWUFALztnnt0kuI5PZAkAq2t1khP0mwfHzsFEFwHlAq5kOgjgBmRzHlKxmMQ66E7RzTEvAbq4S3yzsflBZB9cUYT8cB~HMv2BS0dt8DzNIRtQ4KAZA1lxVTcVPwjRwIr4jjpH3ftPWxiByV9vcqFl65UaanC4mIZAfg-hEBj5Yz8QYPW9iGKtA__&Key-Pair-Id=APKAJWF6YVTMIIYOF3AA",
        type: "media",
        is_media: true,
        is_text: false,
        is_state: false,
        is_payment: false,
        author: "b78ac7c3b348",
        is_author: false,
        author_name: "kaamfuprospus",
        sent_time: "1:44 PM",
        dateCreated: "2022-06-12T16:00:00.000Z",
        key: 1655299207832,
        has_same_author_as_previous_message: false,
        is_in_same_minutue_as_previous_message: false,
        index: 1737,
        last_read_by_users: ["k"],
        data: null,
    },
];

export function getBase64FromImageUrl(image_url) {
    if (!image_url) return null;

    return new Promise(async (resolve, reject) => {
        try {
            const res = await axios.get(`${image_url}`, {
                responseType: "blob",
                headers: {
                    "Cache-Control": "no-cache, no-store, must-revalidate",
                    Pragma: "no-cache",
                    Expires: "0",
                },
            });

            const type =
                res.headers["content-type"] || "application/octet-stream";

            const blob = new Blob([res.data], { type });

            const signed_url = URL.createObjectURL(blob);
            resolve(signed_url);
        } catch (error) {
            console.log("Failed to read base64", error);
            reject(null);
        }
    });
}

export function isFileSizeExceedLimit(
    fileSize,
    maxSize = 100,
    location = "bottom right",
) {
    const { setSnackbar, toggleSnackBarOn, toggleSnackBarOff } = Utilities();

    const mb = fileSize / 1024 / 1024;
    if (mb >= maxSize) {
        toggleSnackBarOff();
        setSnackbar({
            message: `File too big. Maximum File Size ${maxSize}MB.`,
            visible: false,
            timeout: 3000,
            color: "error",
            location,
        });
        toggleSnackBarOn();
        return true;
    }

    return false;
}

export function minutesToHm(minutes = 0) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    const hoursFormatted = hours.toString().padStart(2, "0");
    const minutesFormatted = remainingMinutes.toString().padStart(2, "0");

    return `${hoursFormatted}:${minutesFormatted}`;
}

import { isValidEmail } from "../Utilities/emailValidator.js";

export function validEmail(email) {
    return isValidEmail(email);
}

export async function getImageUrlToBlob(imageUrl, signal) {
    try {
        if (!imageUrl) {
            return null;
        }

        const response = await fetch(imageUrl, { signal, cache: "no-store" });
        if (!response.ok) {
            throw new Error(`Failed to fetch image: ${response.statusText}`);
        }

        const blob = await response.blob();
        return { error: false, data: blob };
    } catch (error) {
        console.log("Error converting image to blob:", error);
        return { error: true, data: error };
    }
}

export function isBase64DataUrl(str) {
    if (!str || typeof str !== "string") return false;
    return /^data:image\/(png|jpg|jpeg|gif|webp|svg\+xml);base64,/.test(str);
}

export function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        if (!(file instanceof File)) {
            reject(new Error("Input must be a File object"));
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            resolve(e.target?.result);
        };
        reader.onerror = (error) => {
            reject(error);
        };
        reader.readAsDataURL(file);
    });
}

export function urlToBase64(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = function () {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            const dataURL = canvas.toDataURL("image/jpeg");
            resolve(dataURL);
        };
        img.onerror = function () {
            reject(new Error("Failed to load image from URL"));
        };
        img.src = url;
    });
}
